<template>
<div class="card-item"
  :id="item.itemId">
  <div class="card-item-heading"
    v-if="item.heading">{{ item.heading }}</div>
  <div class="card-item-content">
    <div v-for="(position, index) in item.data.positions"
      :index="index">
      <div class="manpower">
        <div class="manpower-title">{{ position.kind }}</div>
        <div class="flex">
          <!-- <div class="input-item">
            <label for="">分類</label>
            {{ position.kind }}
          </div> -->
          <div class="input-item">
            <label for="">人数</label>
            <Input placeholder="0"
              v-model.number="position.number" />
          </div>
        </div>
        <div class="input-item">
          <label for="">詳細</label>
          <Input type="textarea"
            :autosize="true"
            placeholder="正社員○名、アルバイト○名、パート従業員○名"
            v-model="position.detail" />
        </div>
      </div>
    </div>
    <div class="input-item mt-1">
      <label for="">人件費支払い</label>
      <Input placeholder="末日〆、翌25日支払 (ボーナスの支給日：12月)"
        v-model="item.data.salaryPayment" />
    </div>
  </div>
</div>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: ['item'],
  computed: {},
  mounted: function () {},
  methods: {}
}
</script>
